import {
  RichTextNode,
  RichTextNodeType,
} from '@/common/components/RichText/RichTextService';

import { HeadingStyles } from './Heading.styles';
import { Typography } from '@mui/material';

interface HeadingProps {
  node: RichTextNode;
}

export default function Heading({ node }: HeadingProps) {
  if (!node.content || node.content.length === 0) return null;

  if (!isHeading(node.nodeType)) {
    return null;
  }

  const headingLevel = node.nodeType.split('-')[1];
  const variant = `h${headingLevel}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

  return (
    <Typography variant={variant} sx={HeadingStyles}>
      {node.content.map((childNode, index) => {
        if (childNode.nodeType === 'text') {
          return <span key={index}>{childNode.value}</span>;
        }
        return null;
      })}
    </Typography>
  );
}

function isHeading(nodeType: string): nodeType is RichTextNodeType {
  const match = nodeType.match(/^heading-(\d)$/);
  return (
    match !== null && parseInt(match[1], 10) >= 1 && parseInt(match[1], 10) <= 6
  );
}
